// extracted by mini-css-extract-plugin
export default {"banner":"not-found-page_banner__FEAf2"};